module.exports = __webpack_public_path__ + "static/story5-social-1200x630-797f784849c2b8cd915498e47c46e4db.jpg";